import { SessionType } from './type';
import { getIdGenerator } from './sdk';
import { MULTIPLAYER_TRACE_PREFIX_MAP, } from './constants/constants.base';
var SessionRecorderIdGenerator = /** @class */ (function () {
    function SessionRecorderIdGenerator() {
        this.generateLongId = getIdGenerator(16);
        this.generateShortId = getIdGenerator(8);
        this.sessionShortId = '';
        this.clientId = '';
        this.sessionType;
    }
    SessionRecorderIdGenerator.prototype.generateTraceId = function () {
        var traceId = this.generateLongId();
        if ((!this.sessionShortId
            && !this.clientId)
            || !this.sessionType) {
            return traceId;
        }
        var sessionTypePrefix = MULTIPLAYER_TRACE_PREFIX_MAP[this.sessionType];
        var prefix = "".concat(sessionTypePrefix).concat([SessionType.SESSION, SessionType.SESSION_CACHE].includes(this.sessionType) ? this.clientId : '').concat(this.sessionShortId);
        var sessionTraceId = "".concat(prefix).concat(traceId.substring(prefix.length, traceId.length));
        return sessionTraceId;
    };
    SessionRecorderIdGenerator.prototype.generateSpanId = function () {
        return this.generateShortId();
    };
    SessionRecorderIdGenerator.prototype.setSessionId = function (sessionShortId, sessionType, clientId) {
        if (sessionType
            && !clientId
            && [
                SessionType.SESSION,
                SessionType.SESSION_CACHE,
            ].includes(sessionType)) {
            throw new Error("Client ID is required for ".concat([
                SessionType.SESSION,
                SessionType.SESSION_CACHE,
            ].join(', '), " session types"));
        }
        this.sessionShortId = sessionShortId;
        this.sessionType = sessionType;
        this.clientId = clientId;
    };
    return SessionRecorderIdGenerator;
}());
export { SessionRecorderIdGenerator };
//# sourceMappingURL=SessionRecorderIdGenerator.js.map